import {createSvgIcon} from "@mui/material";

export const TrashIcon = createSvgIcon(
    <svg
        width="24"
        height="24"
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
    >
      <path
          d="M33.94,45h-20a1.42,1.42,0,0,1-1.42-1.29L10.61,18.2H37.39l-2,25.46A1.41,1.41,0,0,1,33.94,45Z"
          fill="none"
          stroke="#e7505a"
          strokeMiterlimit="10"
          strokeWidth="2"
      />
      <rect
          x="6.45"
          y="8.74"
          width="35.1"
          height="9.46"
          rx="2.01"
          fill="none"
          stroke="#e7505a"
          strokeMiterlimit="10"
          strokeWidth="2"
      />
      <path
          d="M18.51,3H29.7a2.71,2.71,0,0,1,2.71,2.71V8.57a.17.17,0,0,1-.17.17H15.76a.17.17,0,0,1-.17-.17V6A2.92,2.92,0,0,1,18.51,3Z"
          fill="none"
          stroke="#e7505a"
          strokeMiterlimit="10"
          strokeWidth="2"
      />
      <line
          x1="18.21"
          y1="21.29"
          x2="18.21"
          y2="39.53"
          fill="none"
          stroke="#e7505a"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="2"
      />
      <line
          x1="24"
          y1="21.29"
          x2="24"
          y2="39.53"
          fill="none"
          stroke="#e7505a"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="2"
      />
      <line
          x1="29.79"
          y1="21.29"
          x2="29.79"
          y2="39.53"
          fill="none"
          stroke="#e7505a"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="2"
      />
    </svg>,
    "TrashIcon",
)